/* eslint-disable react/prop-types */
import React, { useState, useRef, createRef } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { FlexByRow, FloatRight, XDivider, HalfScreen, makeStyles } from 'irmlib/styles'
import { CheckBox, Label, ToolTip, OutlinedButton, Select } from 'irmlib/components/Controls'
import { TextFieldBorderless, TextareaAutosize } from 'irmlib/components/FormControls'
import * as regx from 'irmlib/components/FormControls/'
import { Edit, InfoOutlined } from 'irmlib/icons'
import { closeGeneralDialog, openGeneralDialog } from 'irmlib/containers'

import Table from '../../Controls/Table'
import FormatCustomOption from './FormatCustomField'
import { validateFormat } from '../../../common/functions'
import { formatPatterns } from '../../../common/constants'
import * as constants from 'irmlib/common/constants'
// import { TextareaAutosize } from '@material-ui/core'
import { getUser } from '../../../redux/global'
import { useTranslation } from 'react-i18next'
import * as appConstants from '../../../../src/services/common/appConstants'
import { setFormStatusError } from '../../../irmlib/src/redux'

// import { useLocation } from 'react-router'


const ROW_SELECTED = 'rowSelected'
const NOT_SELECTED = 'notSelected'

const BottomPaddedDiv = styled('div')`
  padding-bottom: 20px;
`

const TableContainer = styled(BottomPaddedDiv)`
`

const useStyles = makeStyles({
  disabledState: {
    pointerEvents: 'none',
    opacity: '0.4'
  },

  editIcon: {
    cursor: 'pointer'
  }
})

const CenteringFlexRow = styled(FlexByRow)`
  align-items: center;
`

const BoldText = styled(Label)`
  font-weight: 'bold';
`

const TableButtons = props =>
  <FloatRight>
    <CenteringFlexRow>
      <Label>templates.filterFields</Label>
      <XDivider width='10px' />
      <OutlinedButton id={'templateFormation_button_all'} onClick={(e) => props.addFilter('')}>templates.all</OutlinedButton>
      <XDivider width='10px' />
      <OutlinedButton id={'templateFormation_button_includedInTemplate'} onClick={(e) => props.addFilter(ROW_SELECTED)}>templates.includedInTemplate</OutlinedButton>
      <XDivider width='10px' />
      <OutlinedButton id={'templateFormation_button_notIncludedInTemplate'} onClick={(e) => props.addFilter(NOT_SELECTED)}>templates.notIncludedInTemplate</OutlinedButton>
    </CenteringFlexRow>
  </FloatRight>
TableButtons.propTypes = {
  addFilter: PropTypes.func
}

const ColumnWithIcon = () =>
  <CenteringFlexRow>
    <Label>templates.verify</Label>
    <ToolTip id={'templateFormation_verify'} message='messages.doubleKeying' style={{ height: '21px' }}><InfoOutlined /></ToolTip>
  </CenteringFlexRow>

const ColumnTomaxLength = () =>
  <CenteringFlexRow>
    <Label>tableColumns.maxLength</Label>
    <ToolTip id={'templateFormation_maxLength'} message='messages.maxLengthMessage' style={{ height: '21px' }}><InfoOutlined /></ToolTip>
  </CenteringFlexRow>

const TemplateFormat = (props) => {
  const { t } = useTranslation()
  const [disableState, setDisableState] = useState(props.isEdit)
  const { role } = getUser()
  // eslint-disable-next-line no-unused-vars
  // const [cutomFormatValue, setCustomFormatValue] = useState('')
  const [userCreatedCustomFormats, setCustomFormats] = useState({})
  const [cpfRutFormatSelected, setCpfRutFormatSelected] = useState(false)
  const countryCode = props?.getState()?.countryCode
  const regexFormat = props?.skpEncoding[countryCode]?.regex
  const classes = useStyles()
  const customFormatRef = useRef(null)
  const formatFieldData = [
    { value: '', label: 'None' },
    { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
    { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
    { value: 'custom', label: 'Custom' }
  ]
  let createTempPerms = true
  const additionalGivenPermissions = window?.sessionStorage?.getItem('additional-permissions-user')
  if (additionalGivenPermissions !== undefined && additionalGivenPermissions !== 'undefined') {
    const additionalPermissionsForUser = JSON.parse(additionalGivenPermissions)
    const indexOfCreateTemplate = additionalPermissionsForUser?.map(object => object.value).indexOf('createTemplate')
    const getTemplatePermissions = () => {
      if (role === 'USER') {
        return false
      } else if (role === 'SUPERVISOR') {
        if (additionalPermissionsForUser?.[indexOfCreateTemplate]?.enabled) {
          return true 
        } else {
          return false
        }
      } else {
        return true
      }
    }
    createTempPerms = getTemplatePermissions()
  }


  const defaultFormatValues = formatFieldData.map(data => data.value)
  const handleFormatChange = async(data, rowData, oldValue) => {
    rowData.customLength = rowData.actualLength
    if (appConstants.countrySpecificFormats.includes(data)) {
      const indexOfFormat = appConstants.countrySpecificFormats.indexOf(data)
      rowData.customLength = appConstants.cpfRutConfiguration[indexOfFormat].formatLenght
      setCpfRutFormatSelected(rowData.name)
    } else if (appConstants.countrySpecificFormats.includes(oldValue)) {
      if (cpfRutFormatSelected) {
        setCpfRutFormatSelected(false)
      }
    }

    // set format value
    rowData.customFormat = data
    if (data === 'custom') {
      let existingCustomValue = ''
      if (userCreatedCustomFormats[rowData.name]) {
        existingCustomValue = userCreatedCustomFormats[rowData.name]
      }
      // setCustomFormatValue('')

      // handle custom format save
      const handleDialogSave = (specifyLength, regexPattern, rowData) => {
        const customFormatValue = customFormatRef?.current?.getValue()
        rowData.customFormat = customFormatValue
        rowData.specifyLength = specifyLength
        rowData.actualLength = specifyLength
        rowData.regExPattern = regexPattern
        rowData.defaultValue = ''
        props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
        setCustomFormats(oldFormats => {
          return {
            ...oldFormats,
            [rowData.name]: customFormatValue
          }
        })
        // setCustomFormatValue(customFormatValue)
        closeGeneralDialog()
      }

      // set previous value to format field when cancelling custom dialog 
      const handleDialogCancel = () => {
        closeGeneralDialog()
        rowData.customFormat = oldValue
        if (appConstants.countrySpecificFormats.includes(oldValue)) {
          setCpfRutFormatSelected(rowData.name)
          const indexOfFormat = appConstants.countrySpecificFormats.indexOf(oldValue)
          rowData.customLength = appConstants.cpfRutConfiguration[indexOfFormat].formatLenght
        }
        props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
        // setCustomFormatValue(null)
      }

      // open custom format dialog
      openGeneralDialog({
        title: t('formatRequired.dialog.title'),
        message: <FormatCustomOption rowData={rowData} ref={customFormatRef} existingCustomValue={existingCustomValue} handleDialogSave={(specifyLength, regexPattern) => { handleDialogSave(specifyLength, regexPattern, rowData) }} handleCancel={() => { handleDialogCancel() }} />,
        closeX: true,
        paperCustomStyles: { width: '600px' },
        noTranslateTitle: true,
        buttons: <></>,
        onCancel: () => { handleDialogCancel() }
      })
    } else {
      // setCustomFormatValue(data)
      rowData.regExPattern = ''
      if (data) {
        rowData.defaultValue = ''
        const valueArray = data.split('')
        let pattern = ''
        if (appConstants.countrySpecificFormats.includes(data)) {
          const indexOfFormat = appConstants.countrySpecificFormats.indexOf(data)
          rowData.regExPattern = appConstants.cpfRutConfiguration[indexOfFormat].format
        } else if (!defaultFormatValues.includes(data)) {
          valueArray.forEach(val => {
            if (Object.keys(formatPatterns).includes(val)) {
              pattern = pattern + formatPatterns[val]
            } else {
              pattern = ''
            }
          })
          pattern = `^${pattern}$`
          rowData.regExPattern = pattern
        }
      }
      props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
    }
  }

  const Checktruea = rowdata => {
    return (<CheckBox id={`templateFormation_verify_${rowdata.name}`} disabled={!isRowSelected(rowdata) || getUser().role === 'USER' } checked={rowdata.verify} onChange={(e) => handleChangeCheckBox(rowdata, 'verify', e)} />)
  }

  const Checktrueafalse = rowdata => {
    return (<CheckBox id={`templateFormation_verify_${rowdata.name}`} disabled={!isRowSelected(rowdata) || getUser().role === 'USER'} checked={rowdata.verify} onChange={(e) => handleChangeCheckBox(rowdata, 'verify', e)} />)
  }  
  const columns = [
    {
      title: t('tableColumns.fieldId'),
      field: 'name',
      headerAlign: 'center',
      sortable: false,
    },
    {
      title: t('tableColumns.customFieldName'),
      field: 'customName',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        const arrRef = createRef()
        props.arrRefs.push(arrRef)
        const formTemplate = {
          fieldKey: '',
          defaultValue: rowdata.customName,
        }
        props.formTemplates.push(formTemplate)
        return (<TextFieldBorderless id={`templateFormation_customName_${rowdata.customName}`} value={rowdata.customName} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER')} ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChange(rowdata, 'customName', e, arrRef)}>{rowdata.customName}</TextFieldBorderless>)
      }
    },
    {
      title: t('tableColumns.defaultValue'),
      field: 'defaultValue',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        const arrRef = createRef()
        props.arrRefs.push(arrRef)
        const formTemplate = {
          fieldKey: '',
          defaultValue: rowdata.defaultValue,
        }
        props.formTemplates.push(formTemplate)
        return (<TextFieldBorderless id={`templateFormation_defaultValue_${rowdata.name}`} readOnly={rowdata.name === 'maintenanceCode' && true} value={rowdata.defaultValue} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER') } ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChange(rowdata, 'defaultValue', e, arrRef)}/>)
      }
    },
    {
      title: t('tableColumns.required'),
      field: 'isRequired',
      headerAlign: 'center',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => (
        <CheckBox id={`templateFormation_isRequired_${rowdata.name}`} disabled={!isRowSelected(rowdata) || isRowSelectionDisabled(rowdata) || getUser().role === 'USER'} checked={rowdata.isRequired} onChange={(e) => handleChangeCheckBox(rowdata, 'isRequired', e)} />
      )
    },
    {
      title: t('tableColumns.doNotDuplicate'),
      field: 'doNotDuplicate',
      headerAlign: 'center',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        return (<CheckBox id={`templateFormation_doNotDuplicate_${rowdata.name}`} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER')} checked={rowdata.doNotDuplicate} onChange={(e) => handleChangeCheckBox(rowdata, 'doNotDuplicate', e)} />)
      }
    },
    {
      title: <ColumnWithIcon id={'templateFormation_tooltip_verify'} ></ColumnWithIcon>,
      field: 'verify',
      headerAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        const an = Checktruea(rowdata)
        const anfalse = Checktrueafalse(rowdata)
        if (rowdata.verify === true) {
          return an 
        } else {
          return anfalse
        }
      }
    },
    {
      title: t('tableColumns.doNotLock'),
      field: 'doNotLock',
      headerAlign: 'center',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        return (<CheckBox id={`templateFormation_doNotLock_${rowdata.name}`} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER')} checked={rowdata.doNotLock} onChange={(e) => handleChangeCheckBox(rowdata, 'doNotLock', e)} />)
      }
    },
    {
      title: t('tableColumns.formatRequired'),
      field: 'customFormat',
      headerAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        const formatData = [...formatFieldData]
        let displayEmpty = false
        const currentFormatValue = rowdata.customFormat

        if (rowdata.customFormat && !appConstants.countrySpecificFormats.includes(rowdata.customFormat)) {
          // if (!defaultFormatValues.includes(rowdata.customFormat)) {
          //   formatData.push({ value: rowdata.customFormat, label: rowdata.customFormat })
          // }
          // https://gitlab.com/iron-mountain1/gto/enterprise-platforms/enterprisemobile/dxp-gde/gde-web/-/issues/398
          // added below if loop to keep only MM/DD/YYYY & MM/DD/YYYY formats for Date related fields
          if (rowdata.name.match('Date')) {
            formatData.splice(0, formatData.length)
            formatData.push({ value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' }, { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' })
          }

          if (!defaultFormatValues.includes(userCreatedCustomFormats[rowdata.name]) && rowdata.customFormat !== userCreatedCustomFormats[rowdata.name]) {
            userCreatedCustomFormats[rowdata.name] && (formatData.push({ value: userCreatedCustomFormats[rowdata.name], label: userCreatedCustomFormats[rowdata.name] }))
          }
        }

        // #638 & #681 : CPF, RUT Implementation
        if (rowdata.name.match('fileDescription')) {
          if (appConstants.cpfRutConfiguration[0].country.includes(countryCode)) {
            formatData.push({ 
              value: appConstants.cpfRutConfiguration[0].formatCode, 
              label: appConstants.cpfRutConfiguration[0].formatName
            })
          } 
          
          if (appConstants.cpfRutConfiguration[1].country.includes(countryCode)) {
            formatData.push({ 
              value: appConstants.cpfRutConfiguration[1].formatCode, 
              label: appConstants.cpfRutConfiguration[1].formatName
            })
          }
        }
        
        if (cpfRutFormatSelected !== false && rowdata.name.match('fileDescription') && rowdata.name !== cpfRutFormatSelected) {
          formatData.splice(0, formatData.length)
          formatData.push(
            { value: '', label: 'None' },
            { value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' },
            { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' },
            { value: 'custom', label: 'Custom' }
          )
        }

        if (rowdata.name.match('Date')) {
          formatData.splice(0, formatData.length)
          formatData.push({ value: 'MM/DD/YYYY', label: 'MM/DD/YYYY' }, { value: 'DD/MM/YYYY', label: 'DD/MM/YYYY' })
        }

        if (rowdata.customFormat && !defaultFormatValues.includes(rowdata.customFormat) && !appConstants.countrySpecificFormats.includes(rowdata.customFormat)) {
          formatData.push({ value: rowdata.customFormat, label: rowdata.customFormat })
        }

        const defaultValue = rowdata.customFormat || formatData[0].value
        if (!defaultValue) {
          displayEmpty = true
        }

        return (
          <FlexByRow>
            <Select
              defaultValue={defaultValue}
              value={defaultValue}
              items={formatData}
              onChange={(value) => handleFormatChange(value, rowdata, currentFormatValue)}
              id={`${rowdata.name}_format_field`}
              disabled={!isRowSelected(rowdata) || (getUser().role === 'USER')}
              displayEmpty={displayEmpty}
              noTranslateItems
            />
          </FlexByRow>
        )
      }
    },
    {
      title: <ColumnTomaxLength></ColumnTomaxLength>,
      field: 'customLength',
      headerAlign: 'center',
      sortable: false,
      type: 'number',
      render: (rowdata) => {
        const arrRef = createRef()
        props.arrRefs.push(arrRef)
        const formTemplate = {
          fieldKey: '',
          defaultValue: rowdata.specifyLength ? rowdata.specifyLength : rowdata.customLength,
          minValue: 1,
          regx: regx.digitsRegx,
          regxError: regx.digitsRegxError
        }
        props.formTemplates.push(formTemplate)
        return (<TextFieldBorderless id={`templateFormation_maxLength_${rowdata.name}`} value={rowdata.customLength} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER')} ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChange(rowdata, 'customLength', e, arrRef)}/>)
      }    
    }, 
    {
      title: createTempPerms ? t('tableColumns.addFieldInstructions') : t('tableColumns.viewFieldInstructions'),
      field: 'instructionData',
      textAlign: 'center',
      sortable: false,
      render: (rowdata) => {
        const arrRef = createRef()
        props.arrRefs.push(arrRef)
        const formTemplate = {
          fieldKey: '',
          defaultValue: rowdata.instructionData,
        }

        props.formTemplates.push(formTemplate)
        return (<TextareaAutosize id={`templateFormation_instructionData_${rowdata.name}`} value={rowdata.instructionData} disabled={!isRowSelected(rowdata) || (getUser().role === 'USER' || !createTempPerms)} ref={arrRef} fieldTemplate={formTemplate} onChange={(e) => handleChange(rowdata, 'instructionData', e, arrRef)} />)
      }
    },
  ]

  const handleEditIcon = () => {
    setDisableState(false)
  }

  const isRowSelected = (rowdata) => {
    if (rowdata.tableData.checked === false) {
      if (appConstants.countrySpecificFormats.includes(rowdata.customFormat)) {
        setCpfRutFormatSelected(false)
        rowdata.customFormat = ''
        rowdata.regExPattern = ''
      }
    } else {
      if (rowdata.instructionData === undefined) {
        rowdata.instructionData = ''
      }
    }
    return rowdata.tableData.checked
  }

  const handleChangeCheckBox = async (rowdata, field, value, arrRef) => {
    if (field === 'isRequired') {
      rowdata.isRequiredChanged = true
    }
    rowdata[field] = value
  }

  const isRowSelectionDisabled = (rowdata) => {
    return rowdata.isRequired && !rowdata.isRequiredChanged
  }

  const handleChange = async (rowdata, field, value, arrRef) => {
    if (field === 'rowSelection') {
      if (value === true) {
        rowdata.rowSelected = ROW_SELECTED
        props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
      } else {
        rowdata.rowSelected = NOT_SELECTED
        props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
      }
    } else {
      const [hasError, errorMsg] = await ValidateFields(rowdata, field, value, arrRef)
      if (hasError) {
        arrRef?.current?.setErrorMsg(errorMsg, true)
        setFormStatusError()
      } else {
        if (field === 'isRequired') {
          rowdata.isRequiredChanged = true
        }
        rowdata[field] = value
      }
    }
  }

  const ValidateFields = async(rowData, field, value) => {
    let hasError = false
    let errorMsg
    if (field === 'customLength') {
      if (rowData.actualLength < value) {
        errorMsg = t('templates.maxValueError', { maxValue: rowData.actualLength })
        hasError = true
      }
      if (value < 0) {
        errorMsg = t('templates.minValueError', { minValue: 0 })
        hasError = true
      }
      if (!regx.digitsRegx.test(value)) {
        errorMsg = t(regx.digitsRegxError)
        hasError = true
      }
    }
    if (field === 'defaultValue') {
      const { customLength, actualLength, customFormat, regExPattern } = rowData
      const formatRequired = customFormat
      const { isDate, isValidFormat } = validateFormat(formatRequired, regExPattern, value, props?.getState()?.skpinstance, regexFormat)
      const length = customLength || actualLength
      if (length < value.length) {
        errorMsg = t('templates.maxFieldLengthError', { maxLength: length })
        hasError = true
      }
      if (value) {
        if (!isValidFormat) {
          if (isDate) {
            errorMsg = t('templates.invalidDateFormat')
            hasError = true
          } else {
            errorMsg = t('templates.invalidFormat')
            hasError = true
          }
        }
      }
    }
    if (field === 'customName') {
      if (value.length > 30) {
        errorMsg = t('templates.maxFieldLengthError', { maxLength: 30 })
        hasError = true
      }
    }
    return [hasError, errorMsg]
  }

  const getPageData = async (page, pageSize) => {
    setCpfRutFormatSelected(false)
    const templateFields = []
    const dataRows = await props.getPageData(page, pageSize)
    dataRows.forEach((r) => {
      if (r.isSelected) {
        r.tableData = {}

        if (appConstants.countrySpecificFormats.includes(r.customFormat)) {
          setCpfRutFormatSelected(r.name)
        }

        if (props.isEdit) {
          r.tableData.checked = true
        } else {
          if (r.isRequired) {
            r.tableData.checked = true
          } else {
            if (page === 'skpStandardNewFile') {
              r.tableData.checked = false
            } else if (page === 'skpStandardNewBox') {
              r.tableData.checked = false
            } else if (page === 'skpStandardMaintenanceFile') {
              r.tableData.checked = false
            } else if (page === 'skpStandardMaintenanceBox') {
              r.tableData.checked = false
            } else {
              r.tableData.checked = true
            }
          }
        }
        templateFields.push(r)
      }
    })

    if (props.setSelectedTemplateValues) {
      props.setSelectedTemplateValues(templateFields)
    }

    return Promise.resolve(templateFields)
  }

  const onSelectionChange = (rows, row, val) => {
    if (row === undefined && rows.length === 0) {
      const templateValuesFromtable = props.tableRef.current.dataManager.data
      templateValuesFromtable.forEach((data, index) => {
        if (templateValuesFromtable[index].isRequired) {
          templateValuesFromtable[index].tableData.checked = true
        }
      })
      props.tableRef.current.setState(props.tableRef.current.dataManager.getRenderState())
    }
  }

  return (
    <>
      <TableContainer>
        <FlexByRow>
          <HalfScreen>
            <CenteringFlexRow>
              <BoldText noTranslate>{props.title}</BoldText>
              {props.isEdit
                ? <>
                  <XDivider width='10px' />
                  <ToolTip id={'templateFormation_editTooltip'} message='messages.editToolTip' >{(props.jobDetails?.jobStatus === constants.jobStatus.assigned || props.jobDetails?.jobStatus === constants.jobStatus.pending || props.jobDetails?.jobStatus === undefined)
                    ? <>
                      <Edit id={'createJobs_edit'} className={classes.editIcon} onClick={handleEditIcon} />
                    </>
                    : null}
                  </ToolTip>
                </>
                : null
              }
            </CenteringFlexRow>
          </HalfScreen>
        </FlexByRow>
        
        <div className={disableState ? classes.disabledState : ''} >
          <Table
            title={props.title}
            tableRef={props.tableRef}
            totalRecords={200}
            columns={columns}
            getPageData={getPageData}
            rowsPerPageOptions={[30]}
            exportButton={false}
            paging={false}
            draggable={true}
            sorting={false}
            onSelectionChange={onSelectionChange}
            selection={true}
          />
        </div>
      </TableContainer>
    </>
  )
}

TemplateFormat.propTypes = {
  tableRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.any })
  ]),
  title: PropTypes.string,
  jobDetails: PropTypes.string,
  getPageData: PropTypes.func,
  setSelectedTemplateValues: PropTypes.func,
  formTemplates: PropTypes.array,
  arrRefs: PropTypes.array,
  isEdit: PropTypes.bool,
}

export default TemplateFormat
